export default {"src":"/_next/static/media/quote-icon.923f63a5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};